export default __webpack_public_path__ + "static/media/chart3.6ec30cd5.png";